import { Center, Flex, FlexProps } from "@chakra-ui/react";

import { RanaHeading } from "@nens/ranalib";

export interface HeaderBoxProps extends FlexProps {
  name: JSX.Element | string;
  button?: JSX.Element;
  boxHeight?: number | string;
}

export function HeaderBox({ name, boxHeight, button, children, ...rest }: HeaderBoxProps) {
  return (
    <Flex
      flexDir="column"
      borderWidth="base"
      overflow="visible"
      bg="brand.bg"
      rounded="base"
      mt={2}
      w="full"
      {...rest}
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        borderBottomWidth="base"
        bg="brand.cloudy"
        px={4}
        py={button ? 2 : 4}
      >
        <RanaHeading color="brand.clear_creek" type="h6">
          {name}
        </RanaHeading>
        {button}
      </Flex>
      <Center w="full" h={boxHeight ?? "xl"}>
        {children}
      </Center>
    </Flex>
  );
}
